import {
  AcceptedAdAssessmentsService,
  AcceptedSbAssessmentsService,
} from "@common/client"
import { evaluationReportKey, sbEvaluationReportKey } from "./traces"
import { makeAxiosMutation } from "./utils"

export const adComplianceBaseKey = ["ad-compliance"] as const
export const sbComplianceBaseKey = ["sb-compliance"] as const

export const useAcceptAdEvalReportMutation = makeAxiosMutation({
  serviceCall: AcceptedAdAssessmentsService.acceptAssessment,
  invalidates: (p) => [
    evaluationReportKey(p.acceptedAdAssessmentCreate.trace_ad_eval_report_id),
    adComplianceBaseKey,
  ],
})

export const useAcceptSbEvalReportMutation = makeAxiosMutation({
  serviceCall: AcceptedSbAssessmentsService.acceptAssessment,
  invalidates: (p) => [
    sbEvaluationReportKey(p.acceptedSbAssessmentCreate.trace_sb_eval_report_id),
    sbComplianceBaseKey,
  ],
})

export const useExportSbComplianceMutation = makeAxiosMutation({
  serviceCall: AcceptedSbAssessmentsService.exportSbComplianceReport,
  invalidates: () => [],
})
